import React from 'react';

import { ReactComponent as Marker } from 'assets/icons/marker.svg';

const MyMarker = () => {
  return <Marker />;
};

export default MyMarker;
